import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FilePdf } from "@phosphor-icons/react";
import { useApi, API } from "@/lib/api";

export const ExportButton = () => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const exportPdf = async () => {
    setBusy(true);
    try {
      const res = await axios.get(`${API}/reports/board.pdf`, { headers: await api.headers(), responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `calibrunway-board-update-${new Date().toISOString().slice(0, 10)}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Board report downloaded");
    } catch { toast.error("Couldn't create the report"); }
    setBusy(false);
  };
  return (
    <button data-testid="export-board-pdf-btn" onClick={exportPdf} disabled={busy}
      className="flex items-center gap-2 rounded-full border border-[#2A2A2A] px-4 py-1.5 text-xs hover:border-[#00FF9D] hover:text-[#00FF9D] transition-colors disabled:opacity-60">
      <FilePdf size={14} /> {busy ? "Building…" : "Board PDF"}
    </button>
  );
};
